import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './stylesheets/loader.css';
import './stylesheets/style.css';
import './stylesheets/vc-lightblue-button.css';

import "./Common/i18next";
import Login from './components/Login.jsx';

import reportWebVitals from './reportWebVitals';
import { reCaptchaSiteKey } from './components/UserUtility.jsx';

const root = ReactDOM.createRoot(document.getElementById('rootReact'));
root.render(<GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey}><Login /></GoogleReCaptchaProvider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
